import AuthProvider from './features/auth/AuthProvider';
import { ToastProvider } from './components/ui/Toast';
import ScrollToTop from './components/ScrollToTop';
import AppRoutes from './routes';

/**
 * App — root component. BrowserRouter is provided by main.tsx so this
 * component stays testable (wrap with MemoryRouter in tests). AuthProvider
 * must be inside the Router since RequireAuth/LoginPage use react-router hooks.
 */
export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        {/* Must sit inside the Router (main.tsx provides it) — it reads
            useLocation. Renders nothing; see ScrollToTop.tsx for why this is
            app-wide rather than a fix on the Onboarders page alone. */}
        <ScrollToTop />
        <AppRoutes />
      </ToastProvider>
    </AuthProvider>
  );
}
